import { theme as antdTheme } from 'antd';
import type { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  algorithm: [antdTheme.darkAlgorithm],
  token: {
    // Primary blue — solar panel / data accent
    colorPrimary: '#1890ff',
    // Info / secondary — golden energy color
    colorInfo: '#faad14',
    colorWarning: '#faad14',
    colorSuccess: '#52c41a',
    colorError: '#ff4d4f',

    // Background layers
    colorBgBase: '#0a0a0a',
    colorBgContainer: 'rgba(255,255,255,0.04)',
    colorBgElevated: 'rgba(255,255,255,0.06)',
    colorBgLayout: '#060606',
    colorBgSpotlight: 'rgba(255,255,255,0.08)',

    // Text
    colorText: 'rgba(255,255,255,0.88)',
    colorTextSecondary: 'rgba(255,255,255,0.55)',
    colorTextTertiary: 'rgba(255,255,255,0.35)',
    colorTextDisabled: 'rgba(255,255,255,0.25)',

    // Border
    colorBorder: 'rgba(255,255,255,0.10)',
    colorBorderSecondary: 'rgba(255,255,255,0.06)',

    // Shape
    borderRadius: 6,
    borderRadiusLG: 8,
    borderRadiusSM: 4,

    // Typography
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC", "Microsoft YaHei", sans-serif',
    fontSize: 14,
    lineHeight: 1.5,

    // Dimensions — slightly relaxed from extreme compactness
    paddingXXS: 2,
    paddingXS: 4,
    paddingSM: 6,
    padding: 8,
    paddingLG: 12,
    paddingXL: 16,
    marginXXS: 2,
    marginXS: 4,
    marginSM: 6,
    margin: 8,
    marginLG: 12,
    marginXL: 16,
    controlHeight: 28,
    controlHeightSM: 22,
    controlHeightLG: 34,

    // Motion
    motionDurationMid: '0.2s',
    motionDurationFast: '0.1s',
  },
  components: {
    Layout: {
      headerBg: 'rgba(10,10,10,0.85)',
      siderBg: 'rgba(255,255,255,0.03)',
      bodyBg: 'transparent',
    },
    Menu: {
      darkItemBg: 'transparent',
      darkSubMenuItemBg: 'transparent',
    },
    Card: {
      colorBgContainer: 'rgba(255,255,255,0.04)',
    },
    Drawer: {
      colorBgElevated: '#111111',
    },
    Modal: {
      contentBg: '#111111',
      headerBg: '#111111',
    },
  },
};

// ─── Design tokens exported for CSS-in-JS / inline styles ────────────────────
export const colors = {
  bgBase: '#0a0a0a',
  bgPanel: 'rgba(255,255,255,0.04)',
  bgPanelHover: 'rgba(255,255,255,0.07)',
  borderDefault: 'rgba(255,255,255,0.10)',
  primary: '#1890ff',
  gold: '#faad14',
  textPrimary: 'rgba(255,255,255,0.88)',
  textSecondary: 'rgba(255,255,255,0.55)',
} as const;

export const glass = {
  background: 'rgba(6,6,6,0.75)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  border: '1px solid rgba(255,255,255,0.08)',
} as const;
